import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from "axios";
import Moment from 'react-moment';
import AccountForm from './AccountForm/AccountForm';
import AccountInfos from './AccountInfos/AccountInfos';
import AccountPayForm from './AccountPayForm/AccountPayForm';
import AccountPaiments from './AccountPaiments/AccountPaiments';
import {Elements} from 'react-stripe-elements';

import classes from './Account.module.scss';

import { userLogin } from '../../redux/auth/actions';

import moment from 'moment';


class Account extends Component {
    state = {
        now :  moment(),
        edit:false
    }

    showForm = () => {
        this.setState({
            edit:true
        })
    }

    hideForm = () => {
        axios.get("auth/infos").then(res =>{
            this.props.userLogin(res.data);
            this.setState({
                edit:false
            })
        });
        
    }

    render() {
        const expirationdate = moment.unix(this.props.userinfos.expirationtimestamp);
        const expirationdatebefore = moment.unix(this.props.userinfos.expirationtimestamp).subtract(7, 'days');
        const displaybanner = (expirationdatebefore < this.state.now );
        const accountdisabled = expirationdate<=this.state.now;
        let message = `Your subscription will expire ${expirationdate.fromNow()}`;
        if(accountdisabled){
            message = `Your subscription has expired ${expirationdate.fromNow()}`;
        }

        

        return(
            <div  className={classes.AccountContainer}>
                <div className={classes.AccountInfos}>
                    <h1>Your account</h1>
                    { this.props.userinfos.nom  && !this.state.edit ? <AccountInfos buttonClick={ this.showForm } userinfos={this.props.userinfos} />:null }
                    { this.props.userinfos.nom  && this.state.edit ? <AccountForm  buttonClick={ this.hideForm } userinfos={this.props.userinfos}  />:null }
                </div>
                <div className={classes.AccountSubscription}>
                    <h1>Your subscription</h1>
                    { this.props.userinfos.expirationtimestamp ?  <div><p><strong>{message}</strong></p></div>:null }
                    { displaybanner ?  <Elements locale="en_us"><AccountPayForm inEdit={this.state.edit} /></Elements>:null }
                    { this.props.userinfos.payments ? <AccountPaiments paiments={this.props.userinfos.payments} />:null }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
      token: state.auth.token,
      userinfos: state.auth.userinfos,
      termes: state.settings.termes
    }
  };


export default connect(mapStateToProps, {userLogin})(Account);
